export function formatTableTime(date: Date, template: string): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
  
    const isPM = hours >= 12;
    const formattedHours = isPM? hours % 12 || 12 : hours;
    const amPm = isPM? 'PM' : 'AM';
  
    const replacements: { [key: string]: string } = {
      'YYYY': year.toString(),
      'MM': month.toString().padStart(2, '0'), // Используйте 'MM' для месяцев
      'DD': day.toString().padStart(2, '0'),
      'EEEE': dayOfWeek,
      'hh': formattedHours.toString().padStart(2, '0'),
      'mm': minutes.toString().padStart(2, '0'), // Используйте 'mm' для минут
      'ss': seconds.toString().padStart(2, '0'),
      'pm': amPm,
      'am': amPm,
    };
  
    return template.replace(/YYYY|MM|DD|EEEE|hh|mm|ss|pm|am/g, (match) => replacements[match]);
  }
  